import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const KlarnaReturn: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [status, setStatus] = useState<'loading' | 'succeeded' | 'failed' | 'pending'>('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const redirectStatus = params.get('redirect_status');
    const route = localStorage.getItem('klarna-return-route') || 'shipping';

    if (redirectStatus === 'succeeded') {
      setStatus('succeeded');

      // Try to get saved state for the success page
      const savedState = localStorage.getItem('klarna-payment-state');
      const orderId = localStorage.getItem('klarna-order-id') || localStorage.getItem('klarna-oxford-order-id');

      // Clean up localStorage
      localStorage.removeItem('klarna-payment-state');
      localStorage.removeItem('klarna-return-route');
      localStorage.removeItem('klarna-order-id');
      localStorage.removeItem('klarna-oxford-order-id');

      let state: any = {};
      if (savedState) {
        try {
          state = JSON.parse(savedState);
        } catch {
          // Ignore parse errors
        }
      }
      if (orderId) {
        state.orderId = parseInt(orderId);
      }

      // Redirect to the success page
      if (route === 'oxford-packages') {
        // Oxford packages redirects to dashboard on success (same as card payment flow)
        history.replace('/dashboard');
      } else {
        history.replace(`/${route}/success`, state);
      }
    } else if (redirectStatus === 'failed') {
      setStatus('failed');
      setErrorMessage('Your Klarna payment was not completed. Please try again.');
    } else {
      setStatus('pending');
    }
  }, [history, location.search]);

  if (status === 'loading' || status === 'succeeded') {
    return (
      <div className="klarna-return-page">
        <div className="klarna-return-page__content">
          <div className="klarna-return-page__spinner"></div>
          <h2>Processing your payment...</h2>
          <p>Please wait while we confirm your Klarna payment.</p>
        </div>
      </div>
    );
  }

  if (status === 'failed') {
    const route = localStorage.getItem('klarna-return-route') || 'shipping';
    return (
      <div className="klarna-return-page">
        <div className="klarna-return-page__content">
          <h2>Payment Failed</h2>
          <p className="klarna-return-page__error">{errorMessage}</p>
          <button
            className="klarna-return-page__retry-btn"
            onClick={() => {
              localStorage.removeItem('klarna-payment-state');
              localStorage.removeItem('klarna-return-route');
              localStorage.removeItem('klarna-order-id');
              localStorage.removeItem('klarna-oxford-order-id');
              if (route === 'oxford-packages') {
                history.push('/oxford-packages');
              } else {
                history.push(`/${route}/payment`);
              }
            }}
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  // Pending state
  return (
    <div className="klarna-return-page">
      <div className="klarna-return-page__content">
        <div className="klarna-return-page__spinner"></div>
        <h2>Payment Pending</h2>
        <p>Your Klarna payment is being processed. This may take a moment.</p>
      </div>
    </div>
  );
};

export default KlarnaReturn;
